<template>
  <v-container>
    <v-card>
      <v-card-title>
        <date-picker
          v-model="searchDate"
          append-icon="calendar_today"
          label="Data do Exame"
          @input="find"
          hide-details/>
        <v-spacer/>
        <v-text-field
          v-model="search"
          append-icon="search"
          label="Procurar"
          hide-details/>
        <v-btn flat icon @click="find">
          <v-icon medium color="grey darken-1">refresh</v-icon>
        </v-btn>
        <v-btn @click="onNew" color="primary">
          Novo Exame
        </v-btn>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="items"
        :search="search"
        :loading="loading"
        :pagination.sync="pagination"
        :rows-per-page-items="rowsPerPage"
        class="elevation-1">
        <template slot="items" slot-scope="props">
          <td>{{ props.item.created | formatDateTime }}</td>
          <td>{{ props.item.patientName }} <br> <small>{{ props.item.patId }}</small></td>
          <td>{{ props.item.title }} <br> <small>{{ props.item.accessionNo }}</small></td>
          <td>{{ props.item.resource }}</td>
          <td class="justify-center layout px-0">
            <v-tooltip left>
              <v-menu offset-y slot="activator">
                <v-btn
                  slot="activator"
                  class="mx-0"
                  icon>
                  <v-icon
                    small>
                    more_vert
                  </v-icon>
                </v-btn>
                <v-list>
                  <v-list-tile
                    target="_blank"
                    :href="`http://www.ultravideo.com.br/admin/worklist/print?id=${props.item.id}`">
                    <v-list-tile-title>Imprimir Protocolo</v-list-tile-title>
                  </v-list-tile>
                  <v-list-tile @click="onEdit(props.item)">
                    <v-list-tile-title>Editar Exame</v-list-tile-title>
                  </v-list-tile>
                  <v-list-tile @click="onDelete(props.item)">
                    <v-list-tile-title>Remover Exame</v-list-tile-title>
                  </v-list-tile>
                </v-list>
              </v-menu>
              <span>Ações</span>
            </v-tooltip>
          </td>
        </template>
      </v-data-table>
    </v-card>
    <v-dialog v-model="dialog" persistent max-width="700">
      <v-card>
        <v-card-text>
          <v-form>
            <v-container grid-list-md>
              <v-layout row wrap>
                <v-flex xs12 sm6>
                  <h2>Exame</h2>
                  <v-text-field
                    v-model="model.accessionNo"
                    label="AN"
                    required/>
                  <v-text-field
                    v-model="model.title"
                    label="Título"
                    required/>
                  <v-text-field
                    v-model="model.modality"
                    label="Modalidade"
                    required/>
                </v-flex>
                <v-flex xs12 sm6>
                  <h2>Paciente</h2>
                  <v-text-field
                    v-model="model.patId"
                    label="PAT ID"
                    required/>
                  <v-text-field
                    v-model="model.patientName"
                    label="Nome"
                    required/>
                  <v-text-field
                    v-model="model.phone"
                    mask="(##) ##### - ####"
                    label="Telefone"
                    required/>
                    <v-text-field
                    v-model="model.email"
                    label="Email"
                    required/>
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat @click.native="dialog = false">Cancelar</v-btn>
          <v-btn color="green darken-1" flat @click.native="onSave">Salvar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import axios from 'axios'
import moment from 'moment'
import { mapState } from 'vuex'
import DatePicker from '@/components/util/DatePicker'

export default {
  components: {
    DatePicker
  },

  computed: {
    ...mapState({
      user: (state) => state.user,
      company: (state) => state.company
    })
  },

  data () {
    return {
      pagination: {
      },
      headers: [
        { text: 'Data', value: 'created' },
        { text: 'Paciente', value: 'patientName' },
        { text: 'Exame', value: 'title' },
        { text: 'Recurso', value: 'resource' },
        { text: 'Ações', value: 'actions', align: 'center' }
      ],
      rowsPerPage: [10, 15, 25, {'text': '$vuetify.dataIterator.rowsPerPageAll', 'value': -1}],
      loading: false,
      items: [],
      search: '',
      searchDate: '',
      dialog: false,
      model: {}
    }
  },

  created () {
    this.searchDate = moment().format('DDMMYYYY')
  },

  mounted () {
    this.find()
  },

  methods: {
    find () {
      if (!this.company) return
      this.loading = true

      const created = moment(this.searchDate, 'DDMMYYYY').format('DD/MM/YYYY')
      return axios.get(`https://www.ultravideo.com.br/companies/${this.company}/worklist`, {
        params: {
          limit: 1000,
          sort: 'created',
          sortDirection: 'ASCENDING',
          created
        }
      })
      .then(res => {
        this.items = res.data.list
      })
      .catch(err => {
        this.items = []
        console.log(err)
      })
      .finally(() => {
        this.loading = false
      })
    },
    onNew () {
      this.model = {}
      this.dialog = true
    },
    onEdit (item) {
      this.model = item
      this.dialog = true
    },
    onSave () {
      if (this.model.id) {
        this.onPut()
      } else {
        this.onPost()
      }
    },
    onPost () {
      axios.post(`https://www.ultravideo.com.br/companies/${this.company}/worklist`, this.model)
      .then(res => {
        alert('sucesso')
        this.find()
      })
      .catch(err => {
        console.log(err)
      })
      .finally(() => {
        this.dialog = false
      })
    },
    onPut () {
      axios.put(`https://www.ultravideo.com.br/companies/${this.company}/worklist/${this.model.id}`, this.model)
      .then(res => {
        alert('sucesso')
        this.find()
      })
      .catch(err => {
        console.log(err)
      })
      .finally(() => {
        this.dialog = false
      })
    },
    onDelete (item) {
      this.$vuetifyConfirmDialog.open(null, `Tem certeza que deseja remover o AN ${item.accessionNo} ?`, 'Cancelar', 'Confirmar')
      .then(state => {
        if (!state) return

        axios.delete(`https://www.ultravideo.com.br/companies/${this.company}/worklist/${item.id}`)
        .then(res => {
          alert('sucesso')
          this.find()
        })
        .catch(err => {
          console.log(err)
        })
      })
    }
  }
}
</script>

<style scoped>
  iframe {
    widows: 100%;
    height: 400px;
    border: 0;
  }
</style>



// WEBPACK FOOTER //
// src/pages/Worklist.vue